export default (subItemsById, item) => {
  const subItemIdWithQuantity = item.sub_items.find(subItemId => {
    const subItem = subItemsById[subItemId];
    return subItem.quantity;
  });
  return subItemsById[subItemIdWithQuantity].quantity;
};
